export enum DeclarationModeEnum {
    SELF = 1,
    MANAGER = 2,
}
